import { createStandardAction } from 'typesafe-actions'

export const setWindowLocation = createStandardAction('Set_Window_Location')<
  string
>()
